import React, { PropTypes, Component } from 'react';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import MultiSelect from 'components/common/MultiSelect';
import { SparkAccordion } from '../../../ui/spark';
import { isEmpty, map, get, size, isEqual } from 'lodash';
import { sanitizeRetailProductCategoriesToDisplay } from '../../../../utils/configuration-utils';
import './RetailProductsConfiguration.scss'

class RetailProductsConfiguration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isConfigSaving: false
        }
    }

    setDefaultRetailProductCategoriesToDisplay() {
        const { retailProductCategories, currentConfig } = this.props;
        const categoriesToDisplay = get(currentConfig, 'retailProductCategoriesToDisplay', [])
        const sanitizedCategoriesToDisplay = sanitizeRetailProductCategoriesToDisplay(categoriesToDisplay, retailProductCategories);
        if (isEmpty(categoriesToDisplay) && !isEmpty(retailProductCategories)) {
            const categoryCodes = map(retailProductCategories, 'code')
            this.props.setArrayOrObjectInConfig('retailProductCategoriesToDisplay', categoryCodes)
        } else if (size(sanitizedCategoriesToDisplay) < size(categoriesToDisplay)) {
            this.props.setArrayOrObjectInConfig('retailProductCategoriesToDisplay', sanitizedCategoriesToDisplay)
        }
    }

    componentDidMount() {
        this.retailProductsSettingsAccordion = new SparkAccordion(this.retailProductsSettingsAccordion);
        this.retailProductsSettingsAccordion.open("room-category-display")
        this.setDefaultRetailProductCategoriesToDisplay()
    }

    componentDidUpdate(prevProps, prevState) {
        const { saveState, currentConfigCopy, currentConfig, retailProductCategories } = this.props;
        const isConfigSaving = !get(saveState, 'configChange', false) && get(prevProps, 'saveState.configChange', false)
        if (isConfigSaving) {
            return this.setState({
                isConfigSaving
            })
        }

        const isNewConfigSaved = this.state.isConfigSaving && !isEqual(prevProps.currentConfigCopy, currentConfigCopy)
        if (!isEqual(prevProps.currentConfig, currentConfig) ||
            !isEqual(prevProps.retailProductCategories, retailProductCategories) || isNewConfigSaved) {
            this.setState({
                isConfigSaving: false
            })
            this.setDefaultRetailProductCategoriesToDisplay()
        }
    }

    componentWillUnmount() {
        const { currentConfigCopy, retailProductCategories, setArrayOrObjectInConfig } = this.props;
        const retailProductCategoriesToDisplay = get(currentConfigCopy, 'retailProductCategoriesToDisplay', [])
        const selectedCategoriesLength = size(retailProductCategoriesToDisplay)

        if (selectedCategoriesLength > 0 && selectedCategoriesLength === size(retailProductCategories)) {
            setArrayOrObjectInConfig('retailProductCategoriesToDisplay', [])
        }
    }

    render() {
        const {
            isDisabled,
            toggleConfigBoolean,
            currentConfigCopy,
            retailProductCategories,
            setListInConfig
        } = this.props;
        const options = map(retailProductCategories, ({code, name}) => ({ code, label: name }))
        const retailProductCategoriesToDisplay = get(currentConfigCopy, 'retailProductCategoriesToDisplay', [])

        return (
            <div className="retail-products-configuration spark-panel__content">
                <section className="spark-panel__content">
                    <h2>Retail Products - Settings</h2>
                    <div
                        className="spark-accordion"
                        ref={node => (this.retailProductsSettingsAccordion = node)}
                    >
                        <section className="spark-accordion__drawer">
                            <header
                                className="spark-accordion__header"
                                tabIndex="0"
                                aria-controls="room-category-display"
                                aria-expanded="true"
                            >
                                <h3>Room and Category Display</h3>
                            </header>
                            <div className="spark-accordion__content" id="room-category-display">
                                <ConfigurationCheckbox
                                    className="accordion-checkbox"
                                    title="Hide room shopping from my booking engine"
                                    isDisabled={isDisabled}
                                    code="hideRoomShoppingFromMyBookingEngine"
                                    onChange={toggleConfigBoolean}
                                    value={get(currentConfigCopy, 'hideRoomShoppingFromMyBookingEngine', false)}
                                    desc="(only retail products will be displayed with no option to book rooms)."
                                />
                                <MultiSelect
                                    className="spark-mar-t-2"
                                    label="Select product groups/categories to display"
                                    options={options}
                                    selected={retailProductCategoriesToDisplay}
                                    onChange={value => setListInConfig('retailProductCategoriesToDisplay', value)}
                                />
                            </div>
                        </section>
                        <section className="spark-accordion__drawer">
                            <header
                                className="spark-accordion__header"
                                tabIndex="0"
                                aria-controls="guest-settings"
                                aria-expanded="false"
                            >
                                <h3>Guest Settings</h3>
                            </header>
                            <div className="spark-accordion__content" id="guest-settings">
                                <ConfigurationCheckbox
                                    className="accordion-checkbox"
                                    title="Show Special Instructions or Comments field at checkout"
                                    isDisabled={isDisabled}
                                    code="displayOrderCommentArea"
                                    onChange={toggleConfigBoolean}
                                    value={get(currentConfigCopy, 'displayOrderCommentArea', false)}
                                />
                            </div>
                        </section>
                    </div>
                </section>
            </div>
        );
    };
}

RetailProductsConfiguration.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    currentConfig: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    retailProductCategories: PropTypes.array,
    saveState: PropTypes.shape({
        configChange: PropTypes.bool
    }).isRequired,
    setListInConfig: PropTypes.func.isRequired,
    setArrayOrObjectInConfig: PropTypes.func.isRequired,
    toggleConfigBoolean: PropTypes.func.isRequired
};

export default RetailProductsConfiguration;


// WEBPACK FOOTER //
// ./src/components/pages/pages/retailProducts/RetailProductsConfiguration.js